import AppConfig from '@/app.config.js'

import api from "@/services/apiService"

class LottoService {

  /*
  nowResult() {
    return new Promise((resolve, reject) => {
      api.get(AppConfig.api.url + 'result')
        .then(function(response) {
          resolve(response.data)
        })
        .catch(function(error) {
          reject(error)
        });
    });
  }
  */

  saveResult(data) {
    return new Promise((resolve, reject) => {
      api
      .post(process.env.VUE_APP_CLOUD_API + 'admin/result', data)
      .then((response)=>{
        resolve(response.data)
      })
      .catch((error)=>{
        reject(error)
      })
    });
  }

  getResults(lottoType) {
    return new Promise((resolve, reject) => {
      api.get(process.env.VUE_APP_CLOUD_API + 'admin/result/' + lottoType)
      .then((response)=>{
        resolve(response.data)
      })
      .catch((error)=>{
        reject(error)
      })
    });
  }

  getResult(lotto) {
    return new Promise((resolve, reject) => {
      api.get(process.env.VUE_APP_CLOUD_API + 'admin/result/' + lotto.lottoType + '/' + lotto.lottoId)
        .then(function(response) {
          resolve(response.data)
        })
        .catch(function(error) {
          reject(error)
        });
    });
  }

  deleteResult(lotto) {
    return new Promise((resolve, reject) => {
      api.delete(process.env.VUE_APP_CLOUD_API + 'admin/result/' + lotto.lottoType + '/' + lotto.lottoId)
        .then(function(response) {
          resolve(response.data)
        })
        .catch(function(error) {
          reject(error)
        })
    });
  }

  updateResult(lotto, data) {
    return new Promise((resolve, reject) => {
      api.put(process.env.VUE_APP_CLOUD_API + 'admin/result/' + lotto.lottoType + '/' + lotto.lottoId, data)
        .then(function(response) {
          resolve(response.data)
        })
        .catch(function(error) {
          reject(error)
        });
    });
  }

}

export default new LottoService();
